define('shared/util/checkout/emailSubscriptions',[
    'shared/initializer/form/constants'
], function(constants){
    var emailSub = {};

    emailSub.subscriptions = {
        4: constants.FIELD.MemberSubscribeToETPromo,
        5: constants.FIELD.MemberSubscribeToPartnerPromo,
        8: constants.FIELD.MemberSubscribeToSMS,
        17: constants.FIELD.MemberSubscribeToDailyLesson
    };

    emailSub.mailListFields = [
        constants.FIELD.EnglishEmail
    ];

    emailSub.allFields = [emailSub.mailListFields[0]];

    emailSub.emailEnglishFields = [
        // nice naming martin
        constants.FIELD.EMAIL_ENGLISH,
        constants.FIELD.MemberSubscribeToEmailEnglish,
        constants.FIELD.MemberSubscribeToDailyLesson
    ];

    function generateAllFieldsArray() {
        emailSub.allFields = emailSub.allFields.concat(emailSub.emailEnglishFields);

        for(var key in emailSub.subscriptions) {
            if (!emailSub.subscriptions.hasOwnProperty(key)) {
                continue;
            }

            emailSub.allFields.push(emailSub.subscriptions[key]);
        }
    }

    generateAllFieldsArray();

    return emailSub;
});
